/**
 * Cookie consent — domain types (Garante "Linee guida cookie" 10/06/2021 + GDPR).
 *
 * Kept local to the dashboard feature for v1. Phase-2 backend sync can mirror
 * these into packages/shared-types (see CookieConsentContext sync stub).
 */

export enum CookieCategory {
  /** Tecnici/necessari: sempre attivi, non disattivabili. Nessun consenso. */
  NECESSARY = 'necessary',
  /** Analitici anonimizzati: trattati come tecnici (IP mascherato, no incrocio). */
  ANALYTICS = 'analytics',
  /** Profilazione: consenso esplicito obbligatorio, default OFF, revocabile. */
  PROFILING = 'profiling',
}

export type CookieCategoryMap = Record<CookieCategory, boolean>;

/**
 * Record di consenso persistito (prova del consenso).
 * id + version + timestamp costituiscono la traccia di audit lato client.
 */
export interface CookieConsent {
  /** Identificativo univoco della decisione (crypto.randomUUID). */
  id: string;
  /** Versione policy vigente al momento della scelta. */
  version: string;
  /** Stato per categoria. NECESSARY sempre true. */
  categories: CookieCategoryMap;
  /** ISO 8601 — quando l'utente ha effettuato la scelta. */
  timestamp: string;
}
